import { render, staticRenderFns } from "./Testimonials.vue?vue&type=template&id=f447f6fa&scoped=true"
import script from "./Testimonials.vue?vue&type=script&lang=ts"
export * from "./Testimonials.vue?vue&type=script&lang=ts"
import style0 from "./Testimonials.vue?vue&type=style&index=0&id=f447f6fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f447f6fa",
  null
  
)

export default component.exports